import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/web/events/[slug]/ui/LayoutProvider/LayoutProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
